import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/no-danger */
import classnames from 'classnames';
import { LinkVariant } from '../../enums';
import { useLinkClassName } from '../Link';
import { addClassNameToLinksInsideContent } from './addClassNameToLinksInsideContent';
import styles from './Wysiwyg.module.scss';
// For wysiwyg content we specifically allow HTML content
const Wysiwyg = ({ className, content, paddingBottom = true, ...rest }) => {
    const linkClassName = useLinkClassName({ variant: LinkVariant.Grey });
    const contentWithReplacedLinks = content
        ? addClassNameToLinksInsideContent(content, linkClassName)
        : '';
    return (_jsx("div", { "data-padding-bottom": paddingBottom, className: classnames(styles.wysiwyg, className), dangerouslySetInnerHTML: { __html: contentWithReplacedLinks }, ...rest }));
};
export { Wysiwyg };
